import React from 'react'

import { lottieFiles } from '@zet/assets'
import { SH1, Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import LottieView from 'lottie-react-native'

const PdfDownloadLoader = () => {
  return (
    <Stack className="flex-1 bg-white">
      <LottieView
        autoPlay
        className="relative w-full self-center"
        source={lottieFiles.sharePdf}
        style={{ top: '10%' }}
      />
      <SH1 className="w-full  pt-6 text-center">
        {i18n.t('marketingResources.loadingText')}
      </SH1>
    </Stack>
  )
}

export default PdfDownloadLoader
